export default __webpack_public_path__ + "static/media/book-cover.4d9763cb.png";